module.exports = {
  mode: 'jit',
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  important: 'body #appRoot',
  theme: {
    container: {
      center: true,
      padding: {
        DEFAULT: '1.5rem',
        sm: '1.5rem',
        md: '1.75rem',
        lg: '2rem',
        xl: '3rem'
      },
      screens: {
        xl: '1440px'
      }
    },
    fontFamily: {
      sans: ['Helvetica Neue', 'sans-serif']
    },
    fontSize: {
      '3xs': ['7px', '11px'],
      '2xs': ['9px', '11px'],
      xs: ['11px', '14px'],
      sm: ['12px', '14px'],
      base: ['14px', '14px'],
      md: ['16px', '19px'],
      lg: ['18px', '19px'],
      xl: ['20px', '25px'],
      '2xl': ['24px', '29px'],
      arrow: ['36px', '41px']
    },
    fontWeight: {
      light: '300',
      base: '400',
      basemedium: '500',
      semibold: '600',
      bold: '700',
      dark: '900'
    },
    borderWidth: {
      DEFAULT: '1px',
      0: '0',
      1.5: '1.5px',
      2: '2px',
      3: '3px',
      4: '4px',
      6: '6px',
      8: '8px'
    },
    extend: {
      margin: {
        reclg: 'calc(-100vw / 2 + 1024px / 2)',
        recxl: 'calc(-100vw / 2 + 1440px / 2)'
      },
      transitionDuration: {
        400: '400ms'
      },
      colors: {
        product: '#E6E6E6',
        heroarrows: '#777777',
        standard: '#F5F5F5',
        sevengreen: '#00b663',
        sevengreen2: '#1AFA78',
        sevengreen3: '#E6F1CF',
        sevengray: '#E7E7E7',
        popupcolor: '#AFAFAF',
        popupcolor2: '#8E8E8E',
        bnpltc: '#9A9A9A',
        sizeguideslider: '#EBEBEB',
        sizeguidesliderborder: '#E0E0E0'
      },
      animation: {
        fade: 'fadeIn 5s ease-in-out',
        fadeInHome: 'fadeIn 1s',
        fadeIn: 'fadeIn 0.4s',
        fadeOut: 'fadeOut 0.4s'
      },
      keyframes: (theme) => ({
        fadeIn: {
          from: { opacity: 0 },
          to: { opacity: 1 }
        },
        fadeOut: {
          from: { opacity: 1 },
          to: { opacity: 0 }
        }
      }),
      backgroundImage: {
        'discount-icon':
          "url('https://www.footasylum.com/images/articles/footer/CustomerHelp.svg')"
      },
      gridTemplateColumns: {
        24: 'repeat(24, minmax(0, 1fr))'
      }
    }
  },
  plugins: [require('@tailwindcss/aspect-ratio')]
};
